import React from 'react'
import './scss/project.scss'
import { SectionHeader } from '../../styledcomponents/SectionHeader/SectionHeader'
import ProjectCard from '../../styledcomponents/ProjectCard/index'

import "animate.css/animate.min.css";
import ScrollAnimation from 'react-animate-on-scroll';



const Projects = (props) => {
    const qoute1 = "An Angular component library that provides an input select component with nested (tree like structure) options."
    const qoute2 = "An Angular component library that provides a ready-made component which allows user to select multiple roles of interest from a list of specified roles, separated by different permissions name."
    const qoute3 = "Web application that pivots github data, to rank all Angular repositories contributors based on contributions made, amount of followers, public repos and gists published. Created using Angular."
    const qoute4 = "Web application that pivots github data, to rank all Angular repositories contributors based on contributions made, amount of followers, public repos and gists published. Created using React and Typescript."

    return (

        <div className="project" id="project">
            <div className="project__container">

                <SectionHeader>Projects</SectionHeader>

                <div className="project__content">
                    <div className="project__left">
                        <ScrollAnimation animateIn="left_ref" style={{ height: '100%' }} animateOnce={true} duration={0.7}>
                            <ProjectCard
                                summary={qoute1}
                                imageName="npm.svg"
                                name="mat-tree-select-input"
                                link="https://www.npmjs.com/package/mat-tree-select-input"

                            />
                        </ScrollAnimation>
                    </div>
                    <div className="referance__right">
                        <ScrollAnimation animateIn="right_ref" style={{ height: '100%' }} animateOnce={true} duration={0.7}>

                            <ProjectCard
                                summary={qoute2}
                                imageName="npm.svg"
                                name="ngx-roles-selector"
                                link="https://www.npmjs.com/package/ngx-roles-selector"


                            />
                        </ScrollAnimation>


                    </div>
                    <div className="project__left">
                        <ScrollAnimation animateIn="left_ref" style={{ height: '100%' }} animateOnce={true} duration={0.7}>
                            <ProjectCard
                                summary={qoute3}
                                imageName="github.svg"
                                name="Angularank"
                                link="https://angularank.netlify.app/"

                            />
                        </ScrollAnimation>
                    </div>
                    <div className="referance__right">
                        <ScrollAnimation animateIn="right_ref" style={{ height: '100%' }} animateOnce={true} duration={0.7}>

                            <ProjectCard
                                summary={qoute4}
                                imageName="github.svg"
                                name="Angularank"
                                link="https://angularank-rx.netlify.app/"

                            />
                        </ScrollAnimation>


                    </div>
                </div>

            </div>
        </div>

    )
}

export default Projects